import React from "react";
import { STEPS, NIFTY_CONTRACT } from "../../../utils/niftyData";

export default function HowItWorks() {
  const steps = STEPS;
  return (
    <section id="how" className="sec-pad how-sec" data-screen-label="How it works">
      <div className="wrap">
        <div className="sec-tag"><span className="idx">[ 03 ]</span> VERIFICATION PROTOCOL <span className="rule"></span> <span>SELECT · VERIFY · MINT · OWN</span></div>
        <div className="how-grid">
          {steps.map((s, i) => (
            <div className="how-step" data-reveal key={i} style={{ transitionDelay: i * 80 + "ms" }}>
              <div className="how-k mono">{s.k}</div>
              <div className="how-line"></div>
              <div className="how-t">{s.t}</div>
              <div className="how-d">{s.d}</div>
            </div>
          ))}
        </div>
        <div className="how-contract panel mono" data-reveal>
          <span className="how-c-label"><span className="dot dot-live"></span>VERIFIED CONTRACT</span>
          <span className="how-c-addr">{NIFTY_CONTRACT || ""}</span>
          <span className="how-c-net">BASE SEPOLIA · ERC-721</span>
        </div>
      </div>
    </section>
  );
}
